import React from "react";
import { getCurrentLanguage, useTranslation } from "locales";
import { getTermsContent } from "./content";
import "./style.scss";

function PageTerms() {
  // Subscribe to language changes so the page re-renders on toggle.
  useTranslation();
  const C = getTermsContent(getCurrentLanguage());

  return (
    <div className="page-legal">
      <div className="page-legal__container">
        <h1>{C.title}</h1>
        <p className="page-legal__updated">{C.lastUpdated}</p>
        {C.body}
      </div>
    </div>
  );
}

export default PageTerms;
